import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export type TimeMode = 'real-time' | 'historical';
export type FilterType = 'tree_map' | 'toggle';
export type FilterModel = 'entity';

export interface INavItem {
  id: string;
  type: 'chat' | 'settings' | 'user';
  title: string;
  menuItems?: Array<INavItem>;
}

export interface INavBar {
  title: string;
  data: Array<INavItem>;
}

export interface IBatchActionState {
  stopped: boolean;
  started: boolean;
  readyState: boolean;
  agentDestroyed: boolean;
  disable: boolean;
  enable: boolean;
  destroy: boolean;
}

export interface IFilterData {
  id: string;
  type: FilterType;
  model: FilterModel;
  valuesFixed: {
    dimension: string;
  };
  inputsRequired: Array<string>;
  dependsOn: Array<any>;
  def: {
    options: {
      values: Array<string>;
      defaultValues: Array<string>;
      pin: boolean;
      hideUnpinTooltip: boolean;
      width: string;
      height: string;
      wait: number;
      brightness: number;
    };
    outputs: Array<string>;
  };
}

export interface IEntityCacheFinder {
  findEntityCache(entityName: string): IEntityCache;
}
export interface IEntityCache {
  getEntityName(): string;
  getValues(): Array<any>;
  getValuesAsync(): Observable<Array<any>>;
  findById(id: string): IEntity;
  /**
   * @deprecated The method does not take into account a fact that names are not required to be unique
   * (and some entities will have multiple entries for the same name - eg apps). Use #getByName as
   * replacement.
   */
  findByName(name: string): IEntity;
  // same name can be matched to multiple entities (and thats OK!)
  getByName(name: string): IEntity[];
  /**
   * @deprecated The method does not take into account a fact that names are not required to be unique
   * (and some entities will have multiple entries for the same name - eg apps). Use #getByEscapedName
   * as replacement.
   */
  findByEscapedName(name: string): IEntity;

  // same name can be matched to multiple entities (and thats OK!)
  // method implementations are recommended to do case-insensitive match
  getByEscapedName(name: string): IEntity[];
  findByType?(type: any): Array<any>;
}

export interface IEntity {
  isDeleted: boolean;
  getId(): string;
  getName(): string;
  getEscapedName(): string;
}

@Injectable({
  providedIn: 'root'
})
export abstract class EntityCacheProvider implements IEntityCacheFinder {
  abstract findEntityCache(entityName: string): IEntityCache;
}
